import React, { Fragment, useState } from 'react';
import LinkIcon from '@material-ui/icons/Link';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import { Typography, Button, FormControlLabel, OutlinedInput, Menu, MenuItem, Select } from '@material-ui/core';
import { footerMediaChannelTypes } from '../../../../../constants/portalConfigConstant';
import { generateUIId } from '../../../../../services/elementHelperService';

type SocialMediaLinksItemProps = {
	item: any;
	selectedTheme: any;
	handleUpdateFooterItem: (_id: any, _key: string, _value: any) => void;
	handleDeleteFooterItem: (_id: any) => void;
};
const SocialMediaLinksItem = ({
	item,
	selectedTheme,
	handleUpdateFooterItem,
	handleDeleteFooterItem,
}: SocialMediaLinksItemProps) => {
	const [isExpand, setIsExpand] = useState(false);
	const [addChannelAnchorEl, setAddChannelAnchorEl] = useState<null | HTMLElement>(null);
	const { id: socialItemId, links } = item;

	return (
		<>
			<div
				style={{
					border: '1px solid #909CA5',
					borderTopLeftRadius: 4,
					borderTopRightRadius: 4,
					borderBottomLeftRadius: isExpand ? 0 : 4,
					borderBottomRightRadius: isExpand ? 0 : 4,
					cursor: 'pointer',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
				onClick={() => {
					setIsExpand(!isExpand);
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'start',
						alignItems: 'center',
						gap: 10,
						padding: '14px 0 14px 10px',
					}}
				>
					<LinkIcon />
					<Typography variant="body1">{'Social media links'}</Typography>
				</div>
				<div style={{ display: 'flex' }}>
					<Button
						style={{ minWidth: 0, padding: '14px 10px', borderRadius: 0, borderLeft: '1px solid #909CA5' }}
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							handleDeleteFooterItem(socialItemId);
						}}
					>
						<CloseIcon fontSize="small" />
					</Button>
				</div>
			</div>
			{isExpand && (
				<div
					style={{
						borderLeft: '1px solid #909CA5',
						borderRight: '1px solid #909CA5',
						borderBottom: '1px solid #909CA5',
						borderTopLeftRadius: 0,
						borderTopRightRadius: 0,
						borderBottomLeftRadius: 4,
						borderBottomRightRadius: 4,
						padding: '14px 10px',
					}}
				>
					{links.map(({ id, type, url }: any) => {
						return (
							<Fragment key={id}>
								<FormControlLabel
									className={'inspect-media__input--full'}
									style={{ display: 'flex' }}
									control={
										<Select
											value={type}
											variant="outlined"
											style={{ width: '50px' }}
											onChange={(
												event: React.ChangeEvent<{
													name?: string;
													value: unknown;
												}>
											) => {
												const value = event.target.value as string;
												const newLinks = links.map((link: any) => {
													if (link.id === id) {
														return { id: link.id, type: value, url: link.url };
													}
													return link;
												});
												handleUpdateFooterItem(socialItemId, 'links', newLinks);
											}}
										>
											{footerMediaChannelTypes.map(({ key, label }: any) => {
												return (
													<MenuItem
														key={key}
														value={key}
														style={{ textTransform: 'capitalize' }}
													>
														{label}
													</MenuItem>
												);
											})}
										</Select>
									}
									label={
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<Typography variant="body1" style={{ textTransform: 'capitalize' }}>
												Channel
											</Typography>
										</div>
									}
									labelPlacement={'start'}
								/>
								<FormControlLabel
									className={'inspect-media__input--full'}
									style={{ display: 'flex' }}
									control={
										<OutlinedInput
											value={url}
											fullWidth
											onChange={(
												event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
											) => {
												const newLinks = links.map((link: any) => {
													if (link.id === id) {
														return { id: link.id, type, url: event.target.value };
													}
													return link;
												});
												handleUpdateFooterItem(socialItemId, 'links', newLinks);
											}}
											placeholder="Add URL link"
										/>
									}
									label={
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<Typography variant="body1" style={{ textTransform: 'capitalize' }}>
												URL link
											</Typography>
										</div>
									}
									labelPlacement={'start'}
								/>
							</Fragment>
						);
					})}

					<Button
						startIcon={<AddIcon />}
						variant="contained"
						color="primary"
						onClick={(e) => {
							setAddChannelAnchorEl(e.currentTarget);
						}}
					>
						Add channel
					</Button>

					<Menu
						open={Boolean(addChannelAnchorEl)}
						anchorEl={addChannelAnchorEl}
						onClose={() => setAddChannelAnchorEl(null)}
					>
						{footerMediaChannelTypes.map(({ key, label, themeKey }: any) => {
							return (
								<MenuItem
									key={key}
									value={key}
									onClick={() => {
										handleUpdateFooterItem(socialItemId, 'links', [
											...links,
											{
												id: generateUIId(),
												type: key,
												url: selectedTheme?.styling?.[themeKey] ?? '',
											},
										]);
										setAddChannelAnchorEl(null);
									}}
								>
									{label}
								</MenuItem>
							);
						})}
					</Menu>
				</div>
			)}
		</>
	);
};

export default SocialMediaLinksItem;
